import { lazy } from 'react';

export const ChangePassword = lazy(() => import('./ChangePassword.component'));
